
import { Home, FileText, Users, Settings, Brain, TrendingUp, BookOpen, Code, Building, Phone, Shield, ScrollText, DollarSign, Puzzle, Lightbulb, Target, Dna, Zap, BarChart3 } from 'lucide-react';

// Navigation items with i18n keys
export const navigationItems = [
  { path: '/dashboard', label: 'Dashboard', labelKey: 'nav.dashboard', icon: Home },
  { path: '/projects', label: 'Proyectos', labelKey: 'nav.projects', icon: FileText },
  { path: '/team', label: 'Equipo', labelKey: 'nav.team', icon: Users },
  { path: '/settings', label: 'Configuración', labelKey: 'nav.settings', icon: Settings },
];

export const aiFeatures = [
  { path: '/ai-predictive', label: 'IA Predictiva', labelKey: 'nav.aiPredictive', icon: Brain, description: 'Predicciones y análisis de riesgos', descriptionKey: 'nav.predictionsAndRisks' },
  { path: '/analytics', label: 'Análisis Inteligente', labelKey: 'nav.intelligentAnalysis', icon: BarChart3, description: 'Insights y patrones de datos', descriptionKey: 'nav.insightsAndPatterns' },
  { path: '/resources', label: 'Optimización', labelKey: 'nav.optimization', icon: Users, description: 'Recursos y equipos optimizados', descriptionKey: 'nav.optimizedResources' },
  { path: '/automation', label: 'Automatización', labelKey: 'nav.automation', icon: Zap, description: 'Workflows y tareas automáticas', descriptionKey: 'nav.workflowsAndTasks' },
];

export const publicNavigationItems = [
  { path: '/features', label: 'Características', labelKey: 'nav.features', icon: Lightbulb },
  { path: '/pricing', label: 'Precios', labelKey: 'nav.pricing', icon: DollarSign },
  { path: '/integrations', label: 'Integraciones', labelKey: 'nav.integrations', icon: Puzzle },
  { path: '/ai-predictive', label: 'IA Predictiva', labelKey: 'nav.aiPredictive', icon: Brain },
  { path: '/use-cases', label: 'Casos de Uso', labelKey: 'nav.useCases', icon: Target },
  { path: '/user-guides', label: 'Guías de Uso', labelKey: 'nav.userGuides', icon: BookOpen },
  { path: '/blog', label: 'Blog', labelKey: 'nav.blog', icon: FileText },
  { path: '/about-us', label: 'Sobre Nosotros', labelKey: 'nav.aboutUs', icon: Building },
  { path: '/contact', label: 'Contacto', labelKey: 'nav.contact', icon: Phone },
];

export const navigationCategories = {
  product: {
    title: 'Producto',
    titleKey: 'nav.product',
    items: [
      { path: '/features', label: 'Características', labelKey: 'nav.features', icon: Lightbulb },
      { path: '/pricing', label: 'Precios', labelKey: 'nav.pricing', icon: DollarSign },
      { path: '/integrations', label: 'Integraciones', labelKey: 'nav.integrations', icon: Puzzle },
      { path: '/ai-predictive', label: 'IA Predictiva', labelKey: 'nav.aiPredictive', icon: Brain },
      { path: '/use-cases', label: 'Casos de Uso', labelKey: 'nav.useCases', icon: Target },
    ]
  },
  resources: {
    title: 'Recursos',
    titleKey: 'nav.resources',
    items: [
      { path: '/user-guides', label: 'Guías de Uso', labelKey: 'nav.userGuides', icon: BookOpen },
      { path: '/api-docs', label: 'Documentación API', labelKey: 'nav.apiDocs', icon: Code },
      { path: '/blog', label: 'Blog', labelKey: 'nav.blog', icon: FileText },
    ]
  },
  company: {
    title: 'Empresa',
    titleKey: 'nav.company',
    items: [
      { path: '/about-us', label: 'Sobre Nosotros', labelKey: 'nav.aboutUs', icon: Building },
      { path: '/contact', label: 'Contáctanos', labelKey: 'nav.contact', icon: Phone },
      { path: '/privacy-policy', label: 'Política de Privacidad', labelKey: 'nav.privacyPolicy', icon: Shield },
      { path: '/terms-of-service', label: 'Términos de Servicio', labelKey: 'nav.termsOfService', icon: ScrollText },
    ]
  }
};
